'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

const EventComponent = () => {
  const searchParams = useSearchParams();
  const router = useRouter();

  useEffect(() => {
    if (!searchParams) return;

    const pinkey = searchParams.get('pinkey');

    if (pinkey && typeof window !== 'undefined') {
      sessionStorage.setItem('pinkey', pinkey);

      const url = new URL(window.location.href);
      url.searchParams.delete('pinkey');

      router.replace(url.pathname + url.search, { scroll: false });
    }
  }, [searchParams, router]);

  return null;
};

export const Event = () => {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense>
        <EventComponent />
      </Suspense>
    </ErrorBoundary>
  );
};
